import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import {
  setCreatePasswordType,
  setIsAddingNewAccountToExistingAccount,
  setIsAuthenticated,
  setIsCompleteRegister,
  setIsCompletedRegister,
  setIsUserRegistering,
  setRegistrationStep,
} from "../../redux/slices/authSlice";
import { RegisterRequestReviewProps } from "../../types";
import {
  BASE_LOCAL_IMAGES_DIR,
  DefaultNavigateDelay,
} from "../../utils/constants/CommonConstants";
import { timer_48_h_IMG } from "../../utils/constants/Images";
import Button from "../GeneralComponents/Button";
import Modal from "../GeneralComponents/Modal";

const RegisterRequestReview: React.FC<RegisterRequestReviewProps> = ({
  show,
  setShow,
  isCreatingNewAccountFromPreviousAccount,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { changeShowLeaveAuthRoutePopupAuthState } = useAuthContext();

  //?===================Navigate To Home===================
  const navigateToUnderReview = () => {
    if (isCreatingNewAccountFromPreviousAccount) {
      setTimeout(() => {
        navigate("/", { replace: true });
      }, DefaultNavigateDelay);
    } else {
      changeShowLeaveAuthRoutePopupAuthState(false);
      dispatch(
        setIsAuthenticated({
          isAuthenticated: true,
          registrationStep: "register",
        }),
      );
      dispatch(
        setIsCompleteRegister({
          isCompleteRegister: false,
        }),
      );
      dispatch(setIsUserRegistering(false));
      dispatch(setIsCompletedRegister(true));
      dispatch(setCreatePasswordType(""));
      dispatch(setRegistrationStep("register"));
      dispatch(setIsAddingNewAccountToExistingAccount(false));
      localStorage.removeItem("otpDuration");
      setTimeout(() => {
        navigate(`/`, { replace: true });
        window.location.reload();
      }, DefaultNavigateDelay);
    }
  };

  //?====================Handle Submit Via Pressing Enter =============================
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter" && show) {
        navigateToUnderReview();
        setShow(!show);
      }
    };

    if (show) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [show]);

  return (
    <Modal isOpen={show} height="h-fit" onClose={() => {}} disableCancel={true}>
      <div className="flex flex-col items-center justify-center">
        <img
          className="max-w-56"
          src={`${BASE_LOCAL_IMAGES_DIR}/${timer_48_h_IMG}`}
          alt="timer"
          loading="lazy"
        />
        <div className="flex flex-col gap-2 pb-12 text-center">
          <h1 className="text-2xl font-bold text-headingTextColor">
            {t("your_files_under_review")}
          </h1>
          <p className="text-base text-textColor">
            {t("your_files_under_review_desc")}
          </p>
        </div>
        <Button
          title={t("get_started")}
          type="button"
          variant="primary"
          extraClassName="shadow-cta"
          onClick={() => navigateToUnderReview()}
        />
      </div>
    </Modal>
  );
};

export default RegisterRequestReview;
